<div class="overlay">
  <mat-spinner diameter="48"></mat-spinner>
  <span>{{ 'APP.VERSION.UPDATING' | translate }}</span>
</div>
